var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',{staticClass:"mt-3",attrs:{"label":_vm.$t('EnterUrl'),"outlined":"","dense":"","placeholder":"Enter website URL","rules":_vm.urlRules},on:{"blur":_vm.prependHttp},model:{value:(_vm.localUrl),callback:function ($$v) {_vm.localUrl=$$v},expression:"localUrl"}})
}
var staticRenderFns = []

export { render, staticRenderFns }